






























import Vue from "vue";
export default Vue.extend({
  name: "result",
  data: function () {
    return {
      errorMessage: "",
    };
  },
  props: {
    suggestion: Object,
  },
  computed: {
    rootPattern(): string | undefined {
      return this.display("root_pattern");
    },
    portnateau(): string | undefined {
      return this.display("portnataeu");
    },
    compoundNoun(): string | undefined {
      return this.display("compound_noun");
    },
  },
  methods: {
    display(prop: string) {
      if ((this.suggestion["root_pattern"] as string[]).length == 0) {
        this.$emit("rootPatternEmpty");
        this.errorMessage =
          "לצערנו, בשל מחסור במקורות, לא היו בידי אליעזר בוט יהודה מספיק נתונים להצעת חלופות עבור מילה זו :-(";
        return undefined;
      }
      const list = this.suggestion[prop] as string[];
      return list.join(", ");
    },
  },
});
